import React from "react";
import ErrorBoundary from "../../../components/ErrorBoundary";
import DoughnutAndMeterBorrower from "../../../components/DoughnutAndMeterBorrower";

function PastPayment() {
  return (
    <>
      <div className="h-100">
        <ErrorBoundary>
          <DoughnutAndMeterBorrower />
        </ErrorBoundary>
      </div>
    </>
  );
}

export default PastPayment;
